import { render } from "./Compass2.vue?vue&type=template&id=817fc02a&scoped=true"
import script from "./Compass2.vue?vue&type=script&lang=js"
export * from "./Compass2.vue?vue&type=script&lang=js"

import "./Compass2.vue?vue&type=style&index=0&id=817fc02a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817fc02a"]])

export default __exports__